import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../test-utils/utils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DataHooks } from './constants';

export interface PaginationCoreUniDriver extends BaseUniDriver {
  isVisible(): Promise<boolean>;
  getCurrentPage(): Promise<number>;
  getTotalPages(): Promise<number>;
  clickOnPage(page: number): Promise<void>;
  clickNextButton(): Promise<void>;
  clickPreviousButton(): Promise<void>;
}

export const paginationCoreUniDriverFactory = (
  base: UniDriver,
): PaginationCoreUniDriver => {
  const byDataHook = (dataHook: string) => base.$(`[data-hook="${dataHook}"]`);
  return {
    ...baseUniDriverFactory(base),

    /** Check if element is rendered */
    isVisible: async () => byDataHook(DataHooks.pageStrip).exists(),

    /** Returns currently selected page */
    getCurrentPage: async () =>
      parseInt(
        await base.$(`[data-hook~=${DataHooks.currentPage}]`).text(),
        10,
      ),

    /** Returns a total amount of pages available */
    getTotalPages: async () =>
      parseInt(await byDataHook(DataHooks.totalPages).text(), 10),

    /** Clicks on gives page number */
    clickOnPage: async (n: number) => byDataHook(`page-${n}`).click(),

    /** Clicks on next button */
    clickNextButton: async () => byDataHook(DataHooks.next).click(),

    /** Clicks on previous button */
    clickPreviousButton: async () => byDataHook(DataHooks.previous).click(),
  };
};
